import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ApiService } from 'src/app/shared/services/api.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { filterData } from '../shared/data';
import { SearchService } from '../../../shared/services/search.service';
import { environment } from '../../../../environments/environment';
import { SpellCheckerService } from 'ngx-spellchecker';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/shared/services/data.service';
import { StoreService } from 'src/app/core/store/store.service';
import { ExclusiveService } from 'src/app/shared/services/exclusive.service';
import { BudgetService } from 'src/app/shared/services/budget.service';
import { imageTypeCode } from 'src/app/shared/classes/image-type';

@Component({
  selector: 'indiapicture-search-media',
  templateUrl: './search-media.component.html',
  styleUrls: ['./search-media.component.scss']
})

export class SearchMediaComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  fileURL = 'https://raw.githubusercontent.com/JacobSamro/ngx-spellchecker/master/dict/normalized_en-US.dic';

  filterData = filterData;
  products = [];
  perPage = 80;
  type = 'images';
  totalCount = 0;
  orderBy = 'default';
  pageTitle = 'Search';
  subTitle = '';
  searchText = '';
  containerClass = 'container-fluid';
  cols = 'col-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2';
  loaded = false;
  moreLoading = false;
  params: any;
  previewArr = [];
  category = 'creative';
  items = [];
  offers = [];
  isMobile = false;
  headerType: string = environment.headerType;
  isBrowseCategory = 0;
  suggestedWords = [];
  currentUser: any;

  constructor(public activeRoute: ActivatedRoute, public router: Router, public utilsService: UtilsService, public apiService: ApiService,
    private searchService: SearchService,
    private spellCheckerService: SpellCheckerService,
    private httpClient: HttpClient,
    private dataService: DataService, private storageService: StoreService,
    private exclusiveService: ExclusiveService,
    private BudgetService: BudgetService) {
    this.searchService = SearchService.getInstance();

    if (this.router.url.indexOf('/category/') > 0) {
      //  console.log('in category');
      this.isBrowseCategory = 1;
      this.activeRoute.params.subscribe(params => {
        this.type = 'images';
        this.perPage = 80;
        this.containerClass = 'container-fluid';
        this.cols = 'col-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2';
        this.searchText = params['searchText'];
        this.params = [];
        this.params['searchText'] = this.searchText;
        this.params['category'] = 'creative';
        this.searchService.setSearch(this.searchText);
        this.searchService.setCategory(this.params['category']);
      });
      this.activeRoute.queryParams.subscribe(params => {
        this.params['page'] = params['page'] ? params['page'] : 1;

        this.perPage = 80;
        this.getCurrentUser();
      });
    } else {
      this.activeRoute.params.subscribe(params => {
        this.isBrowseCategory = 0;
        this.type = params['type'];
        this.perPage = 80;
        this.containerClass = 'container-fluid';
        this.cols = 'col-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2';
      });


      this.activeRoute.queryParams.subscribe(params => {
        this.params = params;
        this.searchService.setSearch(this.params['searchText']);
        this.searchService.setCategory(this.params['category']);

        this.perPage = 80;
        this.getCurrentUser();
      });
    }

    const user = storageService.getItem('currentUser');
    //  console.log('StorageService => ', user);
    if (user) {
      this.currentUser = user;
      //  console.log('currentUser => ', this.currentUser);
    }
  }

  ngOnInit(): void {
    this.getSettings();
    if (window.innerWidth < 550) {
      this.isMobile = true;
    }


  }

  getCurrentUser() {
    this.dataService.currentData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
      // console.log('dataService component', data);
      if (data) {
        this.currentUser = data;
        // console.log('currentUser from dataService => ', this.currentUser);
        this.loadProducts();
      } else {
        const user = this.storageService.getItem('currentUser');
        if (user) {
          this.currentUser = user;
        }
        this.loadProducts();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  getSettings() {
    this.apiService.fetchSettings().subscribe(result => {
      this.offers = result['data'].offer;
    });
  }

  loadProducts() {
    this.loaded = false;
    this.previewArr = [];

    if (this.params['searchText']) {
      this.searchText = this.params['searchText'];
    } else {
      this.searchText = '';
    }

    if (this.params['orderBy']) {
      this.orderBy = this.params['orderBy'];
    } else {
      this.orderBy = 'default';
    }

    this.category = this.params['category'];
    if (this.params['category'] == 'editorial-videos' || this.params['category'] == 'editorial') {
      this.category = 'editorial';
    } else {
      this.category = 'creative';

    }
    if (this.params['category'] == 'editorial-videos' || this.params['category'] == 'creative-videos') {
      this.type = 'videos';
    } else {
      this.type = 'images';
    }

    this.pageTitle = (this.searchText + ' royalty-free ' + this.type);

    let i = 0;
    if (this.currentUser?.isExclusive == true) {
      if (this.params['category'] == 'editorial-videos' || this.params['category'] == 'creative-videos') {
        this.exclusiveService.getVideos(this.searchText, this.perPage,this.params['page'],'', false, this.params['category'] == 'editorial-videos', this.currentUser?.isAdmin ? 1 : 0,this.currentUser.customers_id, this.currentUser?.search_collection).pipe(takeUntil(this.destroy$)).subscribe(result => {
          // console.log('result => ', result);
        this.products = result.results.map((obj) => {
          obj.category = this.category,
            this.previewArr.push({
              src: obj.preview,
              caption: (obj.caption ? obj.caption : '') + '<br/>' + 'Image ' + i++ + ' of ' + result.results.length,
              thumb: obj.thumbnail
            });
          return obj;
        });
        // console.log('products => ', this.products, this.type);
        this.totalCount = result.total;
        this.loaded = true;
        if (this.totalCount > 0 && this.isBrowseCategory == 1) {
          this.subTitle = this.totalCount + ' ' + this.searchText + ' stock photos, vectors, videos and illustrations are available royalty-free.';
        } else {
          this.subTitle = '';
        }

        this.utilsService.scrollToPageContent();
        this.getArrayOfSuggestedKeyword(this.searchText);
      });
      } else if (this.params['category'] == 'editorial' || this.params['category'] == 'creative') {
        this.exclusiveService.getImages(this.searchText, this.perPage, this.params['page'], '', this.currentUser?.isAdmin ? 1 : 0, false, this.params['category'], this.currentUser?.search_collection).pipe(takeUntil(this.destroy$)).subscribe(result => {
          this.products = result.results.map((obj) => {
            obj.category = this.category,
              this.previewArr.push({
                src: obj.preview,
                caption: (obj.caption ? obj.caption : '') + '<br/>' + 'Image ' + i++ + ' of ' + result.results.length,
                thumb: obj.thumbnail
              });
            return obj;
          });
          this.totalCount = result.total;
          this.loaded = true;
          if (this.totalCount > 0 && this.isBrowseCategory == 1) {
            this.subTitle = this.totalCount + ' ' + this.searchText + ' stock photos, vectors, videos and illustrations are available royalty-free.';
          } else {
            this.subTitle = '';
          }

          this.utilsService.scrollToPageContent();
          this.getArrayOfSuggestedKeyword(this.searchText);
        });
      }
    } else {
      if(this.currentUser && this.currentUser.user_type == 'BUDGET'){
        const budgetFilterParams: { [key: string]: any } = {
          license: this.params['license'] || '',
          orientation: this.params['orientation'] || '',
          // The search service's code for the sidebar's Image Type choice:
          // vector 8, illustration 2, photo or nothing null.
          imageType: imageTypeCode(this.params['type']),
          people: this.params['people'] || '',
          gender: this.params['gender'] || '',
          age: this.params['age'] || '',
          ethnicity: this.params['ethnicity'] || '',
          sort: this.params['sort'] || 'Most Relevant',
          // coll_id is NOT here: it is passed to getImages() instead. Both put it
          // in the query string, and PHP keeps the LAST — so the service's own
          // fallback silently overwrote whatever collection the customer chose.
          collectionType: this.params['collectionType'] || '',
          usage: this.params['usage'] || '',
          page: this.params['page'] || 1
        };
        const budgetFilter = Object.keys(budgetFilterParams)
          .map(key => '&' + key + '=' + encodeURIComponent(budgetFilterParams[key]))
          .join('');
        const pageUrlParams: { [key: string]: any } = {
          license: this.params['license'] || '',
          orientation: this.params['orientation'] || '',
          imageType: this.params['imageType'] || 'all',
          people: this.params['people'] || '',
          gender: this.params['gender'] || '',
          age: this.params['age'] || '',
          ethnicity: this.params['ethnicity'] || '',
          sort: this.params['sort'] || '',
          coll_id: this.params['coll_id'] || '',
          collectionType: this.params['collectionType'] || '',
          usage: this.params['usage'] || '',
          page: this.params['page'] || 1
        };
        const pageUrl = '/search/' + this.searchText + '?' + Object.keys(pageUrlParams)
          .map(key => key + '=' + pageUrlParams[key])
          .join('&');
        this.BudgetService.pageView(pageUrl, 0).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.BudgetService.getImages(this.searchText, this.perPage, this.params['page'], budgetFilter, false, this.params['coll_id'] || '').pipe(takeUntil(this.destroy$)).subscribe(result => {
          this.products = result.results.map((obj: any) => {
            obj.category = this.category,
              this.previewArr.push({
                src: obj.preview,
                caption: (obj.caption ? obj.caption : '') + '<br/>' + 'Image ' + i++ + ' of ' + result.results.length,
                thumb: obj.thumbnail
              });
            return obj;
          });
          this.totalCount = result.total;
          this.loaded = true;
          if (this.totalCount > 0 && this.isBrowseCategory == 1) {
            this.subTitle = this.totalCount + ' ' + this.searchText + ' stock photos, vectors, videos and illustrations are available royalty-free.';
          } else {
            this.subTitle = '';
          }

          this.utilsService.scrollToPageContent();
          this.getArrayOfSuggestedKeyword(this.searchText);
          });
        });
      }else{
        this.apiService.fetchData(this.params, this.perPage, this.type, '').pipe(takeUntil(this.destroy$)).subscribe(result => {
        this.products = result.results.map((obj) => {
          obj.category = this.category,
            this.previewArr.push({
              src: obj.preview,
              caption: (obj.caption ? obj.caption : '') + '<br/>' + 'Image ' + i++ + ' of ' + result.results.length,
              thumb: obj.thumbnail
            });
          return obj;
        });
        this.totalCount = result.total;
        this.loaded = true;
        if (this.totalCount > 0 && this.isBrowseCategory == 1) {
          this.subTitle = this.totalCount + ' ' + this.searchText + ' stock photos, vectors, videos and illustrations are available royalty-free.';
        } else {
          this.subTitle = '';
        }

        this.utilsService.scrollToPageContent();
        this.getArrayOfSuggestedKeyword(this.searchText);
        });
      }
    }

  }

  changeOrderBy(event: any) {
    this.router.navigate([], { queryParams: { orderBy: event.currentTarget.value, page: 1 }, queryParamsHandling: 'merge' });
  }

  toggleSidebar() {
    if (document.querySelector('body').classList.contains('sidebar-filter-active')) {
      document.querySelector('body').classList.remove('sidebar-filter-active');
    } else {
      document.querySelector('body').classList.add('sidebar-filter-active');
    }
  }

  hideSidebar() {
    document.querySelector('body').classList.remove('sidebar-filter-active');
  }

  // tagsArr() {
  //  //  console.log(this.params);
  //     // Object.keys(this.params).forEach(function(key, index) {
  //     //     this.items.push(this.params[key]);
  //     // });
  //     // this.items = Object.values(this.params);
  //     // const paramMap = new Map(Object.entries(obj));
  //     // this.items = this.paramMap.map((obj) => {
  //     //     obj.category = this.category,
  //     //         this.previewArr.push({
  //     //             src: obj.preview,
  //     //             caption: obj.caption + '<br/>' + 'Image ' + i++ + ' of ' + result.results.length,
  //     //             thumb: obj.thumbnail
  //     //         });
  //     //     return obj;
  //     // });
  //
  // }

  removeParam(attr: any, value: any) {
    let url = this.getUrlForAttrs(attr, value);
    this.router.navigate([], { queryParams: { [attr]: this.getUrlForAttrs(attr, value), page: 1 }, queryParamsHandling: 'merge' });
  }

  containsAttrInUrl(type: string, value: string) {
    const currentQueries = this.params[type] ? this.params[type].split(',') : [];
    return currentQueries && currentQueries.includes(value);
  }

  getUrlForAttrs(type: string, value: string) {
    let currentQueries = this.params[type] ? this.params[type].split(',') : [];
    currentQueries = this.containsAttrInUrl(type, value) ? currentQueries.filter(item => item !== value) : [value];
    return currentQueries.join(',');
  }

  public getArrayOfSuggestedKeyword(word) {
    this.httpClient.get(this.fileURL, { responseType: 'text' }).subscribe((res: any) => {
      this.suggestedWords = [];

      this.spellCheckerService.normalizeDictionary(res).then((dic) => {

        const dictionary = this.spellCheckerService.getDictionary(dic);
        const splitted = word.split(' ');
        let str = '';
        let misspell = false;
        if (splitted.length > 1) {
          for (const wordcheck of splitted) {
            const checkRes = dictionary.checkAndSuggest(wordcheck, 5);
            if (checkRes.misspelled) {
              str += checkRes.suggestions[0] + ' ';
              misspell = true;
            } else {
              str += wordcheck + ' ';
            }
          }
          if (misspell) {
            this.suggestedWords = [str.trim()];
          }
        } else {
          const checkRes = dictionary.checkAndSuggest(word, 5);
          if (checkRes.misspelled) {
            this.suggestedWords = checkRes.suggestions;
          }
        }
      });

    });
  }

}
